import { createTheme } from '@mui/material/styles';

const lightPalette = {
  primary: {
    main: 'rgb(11, 108, 206)',
    contrastText: '#fff',
  },
  secondary: {
    main: 'rgb(236, 72, 153)', 
    contrastText: '#fff',
  },
  background: {
    default: '#F4F6FA',
    paper: '#fff',
  },
  text: {
    primary: '#000',
    secondary: '#222',
  },
  error: { main: '#F44336' },
  warning: { main: '#FF9800' },
  info: { main: '#2196F3' },
  success: { main: '#4CAF50' },
  divider: '#E0E0E0',
};

const darkPalette = {
  primary: {
    main: 'rgb(11, 108, 206)', 
    contrastText: '#fff',
  },
  secondary: {
    main: 'rgb(236, 72, 153)', 
    contrastText: '#fff',
  },
  background: {
    default: '#181A20',
    paper: '#23272E',
  },
  text: {
    primary: '#fff', // Branco
    secondary: '#fff', // Branco
  },
  error: { main: '#F44336' },
  warning: { main: '#FF9800' },
  info: { main: '#2196F3' },
  success: { main: '#4CAF50' },
  divider: '#23272E',
};

const themeBase = {
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: 'Inter, Roboto, Arial, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none' as const, fontWeight: 600 },
  },
};

export const getTheme = (mode: 'light' | 'dark') =>
  createTheme({
    ...themeBase,
    palette: {
      mode,
      ...(mode === 'light' ? lightPalette : darkPalette),
    },
  });